import { render } from "./HiddenInput.vue?vue&type=template&id=56363af3&ts=true"
import script from "./HiddenInput.vue?vue&type=script&lang=ts"
export * from "./HiddenInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__